
import Modal from "react-bootstrap/Modal";

import "./index.css";

interface Props {
    show: boolean;
    setShow: (show: boolean) => void;
}


const ModalAguarde = ({
    show,
    setShow }: Props) => {

    return (
        <>
            <Modal
                id="modal-aguarde"
                show={show}
                backdrop="static"
                keyboard={false}
                centered={true}
            >
                <Modal.Body className="text-center text-warning border border-primary rounded">
                            <span className="spinner-center-span">Aguarde...</span>
                </Modal.Body>
            </Modal>


        </>
    )
}

export default ModalAguarde